import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminAssetFormatsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('asset-format');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
